import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { derivatAutoCreateVirtel_postoljeprofil_children, derivatAutoCreateVirtel_postoljeprofil_priprema_ulaza, derivatPoluproizvod_postoljeprofil_cncprogram, derivatPoluproizvod_postoljeprofil_naziv, derivatPoluproizvod_postolje_naziv, _derivat_postolje_pozicijaodvodakondenzata123_final, _derivat_postolje_pozicijaojacanja1234_final } from "./ter-derivat-lib-terkk-postolje";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey } from "./ter-virbom-datarender";


// TER DRAFTEL CODECS LIB

/*
POSTOLJE

- bundle postolje se sastoji od profila postolja a samo postolje kao virtel necemo ni imati jer se ono pretvara u momentu kad se sastavlja u modul.

TODO:
- _bundle_postolje ne obuhvata vise postolja nego vise profila od kojih se sastoji jedno postolje




*/


export const draftel_codecs_pack_terkk$_bundle_postolje = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_postolje.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_postolje',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input
    // vrstaprofila: null,
    // msirinaspoljasnja: null,
    // duzinamodula: null,

    // smerojacanjapostolja: 'PODUZINI',
    smerojacanjapostolja: null, // 2023-08-02 DL: Sirina postolja ne bude po defalt ni jedna.

    sirinapostolja: null,
    duzinapostolja: null,
    visinapostolja: null, // 2023-08-02 DL: Sirina postolja da ne bude po default 200 nego da se mora ukucati uvek.
    sirinaprofilapostolja: 55,
    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_postolje.default_pods_input_state = () => {
  /*
  return {
    vrstaprofila: null,
    msirinaspoljasnja: null,
    duzinamodula: null
  };
  */
  return default_pods_input_state_smart_get('terkk$postolje$profil');
};


draftel_codecs_pack_terkk$_bundle_postolje.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_postolje_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // cncprogram1: '', // NOVO

    // od postolja
    tip: 'STANDARDNI',
    smerojacanjapostolja: 'PODUZINI',
    sirinapostolja: null,
    duzinapostolja: null,
    visinapostolja: null,
    sirinaprofilapostolja: 55,
    dimenzijazapozicije: null,

    // profili postolja
    duzina: null,
    pozicijaprofila: null,
    kolicina: 1,

    pozicijaojacanja1: null,
    pozicijaojacanja2: null,
    pozicijaojacanja3: null,
    pozicijaojacanja4: null,

    pozicijaodvodakondenzata1: null,
    pozicijaodvodakondenzata2: null,
    pozicijaodvodakondenzata3: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_postolje.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "vrstaprofila",
  // "msirinaspoljasnja",
  // "duzinamodula",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_postolje.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_postolje.default_subform_item_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_postolje.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$postolje$profil');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = formState;
  const postoljeProfilNaziv = derivatPoluproizvod_postoljeprofil_naziv(p.tip, p.duzina);
  state.naziv = postoljeProfilNaziv;
  state.termaterijal = "LB00000L";
  state.cncprogram1 = derivatPoluproizvod_postoljeprofil_cncprogram(p.tip);
  let _params;
  if (state.visinapostolja < 100 || state.visinapostolja === 100) {
    // CASE NISKI
    // _params = _getParamsFromLib("terkk$postolje$profil_niski");
    // S4+P4 operacija 3. S4+P4+ERMAKSAN
    _params = {
      virtelclass: "terkk$postolje$profil_niski_opsav2",
      ..._getParamsFromLib("terkk$postolje$profil_niski_opsav2"),
    };
    // TODO
  } else {
    // CASE visoki
    // _params = _getParamsFromLib("terkk$postolje$profil");
    // S4+P4 operacija 2.
    _params = {
      virtelclass: "terkk$postolje$profil_opsav",
      ..._getParamsFromLib("terkk$postolje$profil_opsav"),
    };
  }
  const state2 = {
    virtelschemakey: 'terkk$postolje$profil',
    ...state,
    ..._get_fixed_fields(sema),
    ..._params  // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


draftel_codecs_pack_terkk$_bundle_postolje.bundleDrafel_to_paired_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$postolje');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  delete p._ventilator_params; // brisemo objekat koji je samo za frontend
  const postoljeNaziv = derivatPoluproizvod_postolje_naziv(p.duzinapostolja, p.sirinapostolja, p.visinapostolja, p.smerojacanjapostolja);
  p.naziv = postoljeNaziv;
  //
  const _params = {
    "virtelclass": "terkk$postolje",
    "operacija": "OPSKL",
    "rc": "RCDE",
    tergrupa: "POSTOLJE",
    multitranslator_lang: "terkk$postolje/postolje",
  };
  const virtel = {
    ...p,
    virtelschemakey: 'terkk$postolje',
    "virtelclass": "terkk$postolje",
    paired_with_smartel: true,
    ..._get_fixed_fields(sema),
    ..._params,
    ..._getParamsFromLib("terkk$postolje") // parametri na kraju imaju prioritet
  };
  return virtel; // return virtel
};


/////////


draftel_codecs_pack_terkk$_bundle_postolje.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda
    smerojacanjapostolja: bundle.smerojacanjapostolja,
    sirinapostolja: bundle.sirinapostolja,
    duzinapostolja: bundle.duzinapostolja,
    visinapostolja: bundle.visinapostolja,
    // visina: bundle.visinapostolja, // ovo kasnije izbaciti. za sada samo radi starijih virtela
    sirinaprofilapostolja: bundle.sirinaprofilapostolja,
    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
    vrstaprofila: bundle.vrstaprofila,
    msirinaspoljasnja: bundle.msirinaspoljasnja,
    duzinamodula: bundle.duzinamodula,
  };
  let lifted_up_props = {
    // za pozicije ojacanja
    dimenzijazapozicije: 0,
    duzina_front_1: 0, // NOVO
    duzina_left_1: 0, // NOVO
    pozicijaojacanja1: 0,
    pozicijaojacanja2: 0,
    pozicijaojacanja3: 0,
    pozicijaojacanja4: 0,
    // za pozicije odvoda kondenzata
    pozicijaodvodakondenzata1: 0,
    pozicijaodvodakondenzata2: 0,
    pozicijaodvodakondenzata3: 0,
  };
  //
  if (Array.isArray(bundle._subform_arr)) {
    //
    let _pozicije_arr = [];
    bundle._subform_arr.forEach(postoljeprofil_raw => {
      if (postoljeprofil_raw.tip === 'REINFORCEMENT' || postoljeprofil_raw.tip === 'REINFORCEMENT_1') {
        if (postoljeprofil_raw.dimenzijazapozicije > 0) {
          // preuzimamo dimenziju pozicije kako bi podigli 
          // LIFTING dimenzijazapozicije UP
          lifted_up_props.dimenzijazapozicije = postoljeprofil_raw.dimenzijazapozicije;
        }
        // preuzimamo pozicije profila
        _pozicije_arr.push(postoljeprofil_raw.pozicijaprofila);
      }
      if (postoljeprofil_raw.tip === 'FRONT_1') {
        lifted_up_props.duzina_front_1 = postoljeprofil_raw.duzina;
      };
      if (postoljeprofil_raw.tip === 'LEFT_1') {
        lifted_up_props.duzina_left_1 = postoljeprofil_raw.duzina;
      };
      if (postoljeprofil_raw.tip === 'FRONT' || postoljeprofil_raw.tip === 'FRONT_1') {
        // preuzimamo pozicije odvoda kondenzata
        if (postoljeprofil_raw.pozicijaodvodakondenzata1 > 0) {
          lifted_up_props.pozicijaodvodakondenzata1 = postoljeprofil_raw.pozicijaodvodakondenzata1;
        }
        if (postoljeprofil_raw.pozicijaodvodakondenzata2 > 0) {
          lifted_up_props.pozicijaodvodakondenzata2 = postoljeprofil_raw.pozicijaodvodakondenzata2;
        }
        if (postoljeprofil_raw.pozicijaodvodakondenzata3 > 0) {
          lifted_up_props.pozicijaodvodakondenzata3 = postoljeprofil_raw.pozicijaodvodakondenzata3;
        }
        console.log('+++ lifted_up_props nakon pozicijaodvodakondenzata3', lifted_up_props);
      }
    });
    // FIX za dimenzijazapozicije lifted_up_props.lifted_up_props kada su u pitzanju rucno dodata ojacanja (kao na primer kada ja smerojacanjapostolja === 'POSIRINI' jer se tada uvek ojacanja dodaju rucno).
    if (lifted_up_props.dimenzijazapozicije > 0) {
      // do nothing
    } else {
      // FIX
      if (zajednicki_higher_props_za_items.smerojacanjapostolja === 'PODUZINI') {
        lifted_up_props.dimenzijazapozicije = zajednicki_higher_props_za_items.sirinapostolja;
      }
      if (zajednicki_higher_props_za_items.smerojacanjapostolja === 'POSIRINI') {
        lifted_up_props.dimenzijazapozicije = zajednicki_higher_props_za_items.duzinapostolja;
      }
    }
    //
    if (_pozicije_arr[0] >= 0) {
      lifted_up_props.pozicijaojacanja1 = _pozicije_arr[0];
    }
    if (_pozicije_arr[1] >= 0) {
      lifted_up_props.pozicijaojacanja2 = _pozicije_arr[1];
    }
    if (_pozicije_arr[2] >= 0) {
      lifted_up_props.pozicijaojacanja3 = _pozicije_arr[2];
    }
    if (_pozicije_arr[3] >= 0) {
      lifted_up_props.pozicijaojacanja4 = _pozicije_arr[3];
    }
    //
    let pozicijaojacanja_poduzini_pack = null;
    let pozicijaojacanja_posirini_pack = null;
    if (zajednicki_higher_props_za_items.smerojacanjapostolja === "PODUZINI") {
      pozicijaojacanja_poduzini_pack = "" + lifted_up_props.pozicijaojacanja1 + ":" + lifted_up_props.pozicijaojacanja2 + ":" + lifted_up_props.pozicijaojacanja3 + ":" + lifted_up_props.pozicijaojacanja4;
    }
    if (zajednicki_higher_props_za_items.smerojacanjapostolja === "POSIRINI") {
      pozicijaojacanja_posirini_pack = "" + lifted_up_props.pozicijaojacanja1 + ":" + lifted_up_props.pozicijaojacanja2 + ":" + lifted_up_props.pozicijaojacanja3 + ":" + lifted_up_props.pozicijaojacanja4;
    }
    const pozicijaodvodakondenzata_pack = "" + lifted_up_props.pozicijaodvodakondenzata1 + ":" + lifted_up_props.pozicijaodvodakondenzata2 + ":" + lifted_up_props.pozicijaodvodakondenzata3;
    //
    bundle._subform_arr.forEach(postoljeprofil_raw => {
      let _postoljeprofil_2 = {
        pozicijaojacanja1: null,
        pozicijaojacanja2: null,
        pozicijaojacanja3: null,
        pozicijaojacanja4: null,
        pozicijaojacanja_poduzini_pack,
        pozicijaojacanja_posirini_pack,
        ..._derivat_postolje_pozicijaojacanja1234_final(zajednicki_higher_props_za_items.smerojacanjapostolja, postoljeprofil_raw.tip, zajednicki_higher_props_za_items.sirinaprofilapostolja, lifted_up_props.pozicijaojacanja1, lifted_up_props.pozicijaojacanja2, lifted_up_props.pozicijaojacanja3, lifted_up_props.pozicijaojacanja4, lifted_up_props.dimenzijazapozicije, lifted_up_props.duzina_front_1, lifted_up_props.duzina_left_1),
        pozicijaodvodakondenzata1: null,
        pozicijaodvodakondenzata2: null,
        pozicijaodvodakondenzata3: null,
        pozicijaodvodakondenzata_pack,
        ..._derivat_postolje_pozicijaodvodakondenzata123_final(zajednicki_higher_props_za_items.smerojacanjapostolja, postoljeprofil_raw.tip, lifted_up_props.pozicijaodvodakondenzata1, lifted_up_props.pozicijaodvodakondenzata2, lifted_up_props.pozicijaodvodakondenzata3, lifted_up_props.duzina_front_1)
      };
      // console.log('+++POSTOLJE');
      // console.log(_postoljeprofil_2);
      //
      let draftel_postoljeprofil = {
        ...draftel_codecs_pack_terkk$_bundle_postolje.default_subform_item_preset_state(),
        ...postoljeprofil_raw,
        ..._postoljeprofil_2,
        ...zajednicki_higher_props_za_items,
        multitranslator_lang: "terkk$postolje/postolje_profil",
      };
      _unbundled_subDraftel_arr.push(draftel_postoljeprofil);
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_postolje.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$postolje');

  let virbom_ref_parent = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  let paired_virtel = draftel_codecs_pack_terkk$_bundle_postolje.bundleDrafel_to_paired_virtel(bundleDraftel);

  // const local_graphlevel = 1;
  // _virbom_manipulator.add_as_first_virtel(virbom_ref_parent, paired_virtel);

  // KORAK DODAVANJE CHILDRENA OD paired_virtel-a

  // const _unbundled_subDraftel_arr = draftel_codecs_pack_terkk$_bundle_postolje.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);
  // rastavljamo bundle na pojedinacne p pomocu codec-a
  let postoljeProfilArr = draftel_codecs_pack_terkk$_bundle_postolje.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);
  console.log('postoljeProfilArr unbundle-ovano sledece ', postoljeProfilArr);

  /*
  let pods_input_za_derivate = derAutoCreateVirbom_terkk_ppv_prepare_vir_input(paired_virtel); // ??? 
  let _der_virtel_children = derAutoCreateVirbom_terkk_ppv_children(pods_input_za_derivate, _unbundled_subDraftel_arr);
  console.log('_der_virtel_children ppv', _der_virtel_children);
  // USISAVANJE
  */

  ////
  const _first_postoljeprofil = postoljeProfilArr[0];
  paired_virtel = {
    ...paired_virtel,
    pozicijaojacanja_poduzini_pack: _first_postoljeprofil.pozicijaojacanja_poduzini_pack,
    pozicijaojacanja_posirini_pack: _first_postoljeprofil.pozicijaojacanja_posirini_pack,
    pozicijaodvodakondenzata_pack: _first_postoljeprofil.pozicijaodvodakondenzata_pack,
  }; // TEMP BUDZENJE
  _virbom_manipulator.add_as_first_virtel(virbom_ref_parent, paired_virtel);

  // Sad prodjem kroz unbundleovani array i spakujem svaki kao ostale poluproizvode
  postoljeProfilArr.forEach((draftel_postoljeprofil, index) => {
    // KORAK poluproizvod level 3 virtel
    // novonastali elementi raspakovani iz bundlea i oni jos uvek nemaju svoje ID-ove. Sada je potrebno da im dodelimo ID pomocu _enrichWithFreshSubkey()
    // graphlevel: 3,
    let virtel_postoljeprofil = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
      ...draftel_codecs_pack_terkk$_bundle_postolje.subDrafel_to_virtel(draftel_postoljeprofil),
      // virtelschemakey: 'terkk$postolje$profil',
    });
    // zatim preuzimamo taj novi ID da bi children elementi koji slede imali za parent_subkey.
    console.log('virtel_postoljeprofil', virtel_postoljeprofil);
    const local_graphlevel = 1;
    _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_postoljeprofil, local_graphlevel);

    // let p = virtel_postoljeprofil;

    // KORAK pripreme derivata za
    // PROFILI POSTOLJA
    // const _subform_arr = p._subform_arr;
    let pods_input_za_derivate = derivatAutoCreateVirtel_postoljeprofil_priprema_ulaza(virtel_postoljeprofil); // TODO ???
    // let _derivati_postoljeprofil = derivatAutoCreateVirtel_postoljeprofil(pods_input_za_derivate, _subform_arr);
    let _derivati_postoljeprofil = derivatAutoCreateVirtel_postoljeprofil_children(pods_input_za_derivate);
    console.log('_derivati virteli postolje', _derivati_postoljeprofil);
    // USISAVANJE
    _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati_postoljeprofil, local_graphlevel + 1, virbomCounter.generateFreshSubkey);
    ////////////////////

    // ***ZAVRSENI KORACI ZA JEDAN pp3

  }); // end of postoljeProfilArr forEach

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);

  ////
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref_parent, virbom_ref, 2, null);
  const virbom_seq_parent = _virbom_manipulator.deinit(virbom_ref_parent);

  // return virbom_seq; // return virbom
  return virbom_seq_parent; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_postolje.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$_bundle_postolje.default_subform_item_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_postolje.keys_for_direct_cloning)
  };
  //
  return state;
};


draftel_codecs_pack_terkk$_bundle_postolje._virtelArr_to_bundleDraftel = (virtel_postolje_arr, _generate_fresh_subkey, _generateFreshTempkey) => {
  // TO FORM
  // virtel elk arr to single draftel _bundle_eliminatorkapi
  // _bundle_eliminatorkapi ne treba bundle_id jer svi elk. od jednog projekta koji pripadaju jednom modulu su uvek jedan bundle. Dakle za bundlovanje se koristi parent_subkey (to je id parent modula).
  //
  console.log('----------POSTOLJE----------');
  console.log('CODEC MAKE BUNDLE _virtelArr_to_bundleDraftel() - virtel_postolje_arr:');
  console.log(virtel_postolje_arr);
  let parent_subkey_arr = [];
  virtel_postolje_arr.forEach((item) => {
    if (parent_subkey_arr.includes(item.parent_subkey)) {
      // parent_subkey vec dodat
    } else {
      parent_subkey_arr.push(item.parent_subkey);
    }
  });
  //
  let bundle_arr = [];
  parent_subkey_arr.forEach((parent_subkey) => {
    // za svaki modul pravimo jedan _bundle_postolje
    let _subform_arr = [];
    const bundle_id = _generate_fresh_subkey();
    virtel_postolje_arr.forEach(virtel => {
      if (virtel.parent_subkey === parent_subkey) {
        const draftel_item = {
          ...draftel_codecs_pack_terkk$_bundle_postolje.virtel_to_subDraftel(virtel),
          tempkey: _generateFreshTempkey(),
        };
        console.log('virtel_to_subDraftel return:', draftel_item);
        _subform_arr.push(draftel_item);
      }
    });
    if (js_utils.is_object(_subform_arr[0])) {
      const _first_item = _subform_arr[0];
      const zajednicki_higher_props_za_items = {
        parent_subkey,
        // superkey: bundle.superkey, // ???
        // bundle_id: p.bundle_id,
        subkey: bundle_id,
        // od poluproizvoda
        smerojacanjapostolja: _first_item.smerojacanjapostolja,
        sirinapostolja: _first_item.sirinapostolja,
        duzinapostolja: _first_item.duzinapostolja,
        visinapostolja: _first_item.visinapostolja,
        sirinaprofilapostolja: _first_item.sirinaprofilapostolja,
        // pods_input TODO Da li treba bolje resenje?
        flag_custom_pods_input: _first_item.flag_custom_pods_input,
        vrstaprofila: _first_item.vrstaprofila,
        msirinaspoljasnja: _first_item.msirinaspoljasnja,
        duzinamodula: _first_item.duzinamodula,
      };
      let bundleDraftel = {
        // _draftelschemakey: 'terkk$_bundle_postolje',
        ...draftel_codecs_pack_terkk$_bundle_postolje.default_preset_state(),
        // ...draftel_codecs_pack_terkk$_bundle_postolje.default_subform_item_preset_state(),
        _subform_arr: _subform_arr,
        ...zajednicki_higher_props_za_items
      };
      bundle_arr.push(bundleDraftel);
    }
  });
  console.log('CODEC output BUNDLES bundle_arr');
  console.log(bundle_arr);
  return bundle_arr;
};

